import { Bookmarker, FollowAlertManager } from '@prismamedia/bookmarker'

export default class InitBookmark {
	constructor() {
		new Bookmarker()
		new FollowAlertManager()
	}
}
